import { createContext } from "react";
import { MessagesContextData } from "./types";

export const MessagesContext = createContext({} as MessagesContextData);
